import { createFileRoute } from '@tanstack/react-router';
import { PaymentRoute } from '../-PaymentRoute';

export const Route = createFileRoute('/_secured/payment')({
  component: PaymentRoute,
});
